module.exports = __webpack_public_path__ + "statics/img/4-8.daf5573.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/product/icon/4-8.png
// module id = mNCm
// module chunks = 1